module.exports = {
  "version": "0.22.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 88
// module chunks = 5